import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const menuBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Меню',
        url: '',
    },
]);
